import React, {
  useRef,
  useState,
  useEffect,
  useCallback,
  useContext,
} from "react";
// import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";

import { VariableSizeList as List } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";
import Comment from "./Comment";
import { store } from "./store";
import { store as commentStore } from "./commentStore";

import { SizeContext, DEFAULT_HEIGHT } from "./SizeContext";

// Styled component to replace makeStyles
const Root = styled("div")(({ theme }) => ({
  width: "100%",
  height: "100%",
  // maxWidth: 300,
  backgroundColor: theme.palette.background.paper,
}));

// Previously inlined helper
const CallbackComp = ({ callback }) => {
  useEffect(() => callback(), [callback]);
  return null;
};

export default function VirtualizedList(props) {
  const { state } = useContext(store);
  const { state: commentState } = useContext(commentStore);
  const { comments } = commentState;
  const { commentScroll } = state;

  const listRef = useRef();
  const [autoScroll, setAutoScroll] = useState(true);
  const sizeMap = useRef({});
  const setSize = useCallback((index, size) => {
    sizeMap.current = { ...sizeMap.current, [index]: size };
  }, []);
  const getSize = useCallback(
    (index) => sizeMap.current[index] || DEFAULT_HEIGHT,
    []
  );

  const renderRowCallback = useCallback(
    ({ index, style, data, isScrolling }) => {
      const comment = data.comments[index];

      return (
        <div key={index} style={style}>
          <Comment index={index} comment={comment} />
          {isScrolling && autoScroll && (
            <CallbackComp callback={() => setAutoScroll(false)} />
          )}
          {!isScrolling && data.comments.length - index < 2 && (
            <CallbackComp callback={() => setAutoScroll(true)} />
          )}
        </div>
      );
    },
    [autoScroll]
  );

  useEffect(() => {
    if (
      autoScroll &&
      commentScroll &&
      comments.length > 0 &&
      listRef?.current?.scrollToItem
    ) {
      listRef.current.scrollToItem(comments.length - 1, "end");
    }
  }, [comments.length]);

  return (
    <Root>
      <SizeContext.Provider value={{ setSize, listRef }}>
        <AutoSizer>
          {({ height, width }) => (
            <List
              ref={listRef}
              useIsScrolling
              height={height}
              width={width}
              itemSize={getSize}
              itemCount={comments.length}
              itemData={{ comments }}
            >
              {renderRowCallback}
            </List>
          )}
        </AutoSizer>
      </SizeContext.Provider>
    </Root>
  );
}
